import React, {useEffect, useState} from "react";
import "./style.css";
import {Accordion} from "../../accordion";

const SearchList = ({ searchResults, scrollRef, selectedCategory, categoriesList }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleAccordionClick = (expanded, index) => {
    setExpandedIndex(!expanded ? undefined : index);
  };

  const getCategoryName = (categoryId) => {
    const category = categoriesList.find(cat => cat.id === categoryId);
    return category ? category.name : '';
  };

  const getCategorySlug = (categoryId) => {
    const category = categoriesList.find(cat => cat.id === categoryId);
    if (!category) return '';
    return category.name
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  return (
    <div className="section-data-wrapper" ref={scrollRef}>
      {React.Children.toArray(
        searchResults.map((item, index) => (
          <Accordion
            title={item[0]}
            index={index}
            expanded={index === expandedIndex}
            onClick={(e, expanded) => handleAccordionClick(expanded, index)}
            key={index}
            setExpandedIndex={setExpandedIndex}
            categoryId={selectedCategory}
            categoryName={getCategoryName(selectedCategory)}
            categoriesList={categoriesList}
          >
            <span dangerouslySetInnerHTML={{ __html: item[1] }} />
          </Accordion>
        ))
      )}
    </div>
  );
};

export default SearchList;
